/* NOTE: bootstrap/ is loaded from node_modules/ using sass-loader */

// SASS IMPORTS
@use 'sass:math';

// BOOTSTRAP 5 VARIABLES

// 1. Include functions first (so you can manipulate colors, SVGs, calc, etc)
@import 'bootstrap/scss/functions';

// 2. Include any default variable overrides here

@import 'themes/layout-variables';

// 3. Include remainder of required Bootstrap stylesheets

@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/variables-dark';
@import 'bootstrap/scss/maps';
@import 'bootstrap/scss/mixins';
@import 'bootstrap/scss/utilities';

// BOOTSTRAP 5 IMPORTS

@import 'bootstrap/scss/root';
@import 'bootstrap/scss/reboot';
@import 'bootstrap/scss/type';
@import 'bootstrap/scss/images';
@import 'bootstrap/scss/containers';
@import 'bootstrap/scss/grid';
@import 'bootstrap/scss/tables';
@import 'bootstrap/scss/forms';
@import 'bootstrap/scss/buttons';
@import 'bootstrap/scss/transitions';
@import 'bootstrap/scss/dropdown';
@import 'bootstrap/scss/button-group';
@import 'bootstrap/scss/nav';
@import 'bootstrap/scss/navbar';
@import 'bootstrap/scss/card';
@import 'bootstrap/scss/accordion';
@import 'bootstrap/scss/breadcrumb';
@import 'bootstrap/scss/pagination';
@import 'bootstrap/scss/badge';
@import 'bootstrap/scss/alert';
@import 'bootstrap/scss/progress';
@import 'bootstrap/scss/list-group';
@import 'bootstrap/scss/close';
@import 'bootstrap/scss/toasts';
@import 'bootstrap/scss/modal';
@import 'bootstrap/scss/tooltip';
@import 'bootstrap/scss/popover';
@import 'bootstrap/scss/carousel';
@import 'bootstrap/scss/spinners';
@import 'bootstrap/scss/offcanvas';
@import 'bootstrap/scss/placeholders';
@import 'bootstrap/scss/helpers';
@import 'bootstrap/scss/utilities/api';

// LAYOUT

@import 'layout/layout';

// UTILS

@import 'utils/helpers';
@import 'utils/backgrounds';
@import 'utils/animate';
@import 'utils/comps-animations';

// ELEMENTS

@import 'elements/buttons';
@import 'elements/dropdown';
@import 'elements/navs';
@import 'elements/badges';
@import 'elements/cards';
@import 'elements/tabs';
@import 'elements/accordions';
@import 'elements/modals';
@import 'elements/loaders';
@import 'elements/progressbar';
@import 'elements/timeline';
@import 'elements/listgroup';
@import 'elements/forms';
@import 'elements/pagination';
@import 'elements/chat';
@import 'elements/forms-wizard';

// DASHBOARD BOXES

@import 'widgets/chart-boxes/chart-boxes';
@import 'widgets/content-boxes/content-boxes';
@import 'widgets/profile-boxes/profile-boxes';

// PAGES

@import 'pages/userpages';

// Applications

@import 'applications/applications-base';

// COMPONENTS

// Perfect Scrollbar
@import 'components/perfect-scrollbar/perfect-scrollbar';

// RC Tabs
@import 'components/rc-tabs/rc-tabs';

// Loading Buttons
@import 'components/loading-buttons/loading-buttons';

// Hamburger Button
@import 'components/hamburgers/hamburgers';

// Drawer
@import 'components/drawer/drawer';

// Notifications
@import 'components/notifications/sweetalerts';
@import 'components/notifications/toastify';

// Modals
@import 'components/modals/rodal';

// Progress Bar
@import 'components/progress-bar/progress-bar';

// Slick Carousel
@import 'components/slick-carousel/slick/slick';

// Block loading
@import 'components/block-loading/block-loading';

// Popovers & Tooltips
@import 'components/popovers-tooltips/popovers-tooltips';

// Sticky Elements
@import 'components/sticky-elements/sticky-elements';

// Calendar
@import 'components/calendar/calendar';

// Splitters
@import 'components/splitters/splitters';

// Tree View
@import 'components/tree-view/tree-view';

// Tables
@import 'components/tables/tables';

// Icons
@import 'components/icons/linearicons';
@import 'components/icons/p7icons';

// FORMS

@import 'components/forms/datepicker/datepicker';
@import 'components/forms/rangeslider/rangeslider';
@import 'components/forms/multiselect/multiselect';
@import 'components/forms/wysiwyg/wysiwyg';
@import 'components/forms/toggle-switch/switch';
@import 'components/forms/dropzone/dropzone';
@import 'components/forms/typeahead/typeahead';

// REACT WIDGETS (Disabled for React 19 compatibility)

// @import "components/react-widgets/scss/react-widgets";

// DEMO

@import 'demo-ui/demo';

// Responsive

@import 'layout/responsive/responsive-base';

// ORIGINAL ARCHITECTUI NAVIGATION STYLES

// Navigation Menu Vertical
.vertical-nav-menu {
  position: relative;

  &::after {
    content: ' ';
    pointer-events: none;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }

  .metismenu-container,
  .metismenu-item {
    margin: 0;
    padding: 0;
    position: relative;
  }

  .metismenu-container {
    list-style: none;
    text-align: left;

    &:before {
      opacity: 0;
      transition: opacity 300ms;
    }

    .metismenu-link {
      transition:
        transform 0.2s,
        height 300ms,
        color 300ms,
        background-color 300ms;
      display: flex;
      align-items: center;
      line-height: 2.5rem;
      height: 2.5rem;
      padding: 0 $layout-spacer-x 0 45px;
      position: relative;
      border-radius: $border-radius;
      color: $gray-800;
      white-space: nowrap;

      &:hover {
        background: $dropdown-link-hover-bg;
        text-decoration: none;

        i.metismenu-icon {
          opacity: 0.6;
        }

        i.metismenu-state-icon {
          opacity: 1;
        }
      }

      &.active {
        color: $primary;
        background: $dropdown-link-hover-bg;
      }

      &.has-active-child,
      &.active {
        font-weight: bold;
      }
    }

    i.metismenu-state-icon,
    i.metismenu-icon {
      text-align: center;
      width: 34px;
      height: 34px;
      line-height: 34px;
      position: absolute;
      left: 5px;
      top: 50%;
      margin-top: -17px;
      font-size: 1.5rem;
      opacity: 0.3;
      transition: color 300ms;
    }

    i.metismenu-state-icon {
      transition: transform 300ms;
      left: auto;
      right: 5px;

      &.rotate-minus-90 {
        transform: rotate(-180deg);
      }
    }

    .metismenu-container {
      transition: padding 300ms;

      &.visible {
        padding: 0.5em 0 0 2rem;

        &:before {
          content: '';
          height: 100%;
          opacity: 1;
          width: 3px;
          background: $dropdown-link-hover-bg;
          position: absolute;
          left: 20px;
          top: 0;
          border-radius: 15px;
        }

        & > .metismenu-item > .metismenu-link {
          height: 2.3em;
          line-height: 2.3em;
          color: $gray-600;
          margin: 0 0 3px;
          padding-left: 35px;

          &:hover {
            color: $primary;
          }

          .metismenu-icon {
            display: none;
          }

          &.active {
            color: $primary;
            background: $dropdown-link-hover-bg;
          }
        }
      }

      .metismenu-item > .metismenu-link {
        height: 0;
        overflow: hidden;
      }

      .metismenu-link {
        padding-left: 35px;
      }
    }
  }
}

// CUSTOM FIXES FOR UI ISSUES

// Fix: User profile dropdown positioning on desktop
@media (min-width: 768px) {
  .header-btn-lg .dropdown-menu {
    position: absolute !important;
    left: auto !important;
    right: 0 !important;
    top: 100% !important;
    transform: none !important;
    width: auto !important;
    min-width: 280px !important;
    max-width: 320px !important;
  }
}

// Fix: Badge text color override
.badge.text-bg-success,
.badge.text-bg-success small {
  color: white !important;
}

// ORIGINAL ARCHITECTUI NAVIGATION STYLES
@import 'layout/sidebar/modifiers/_navmenu-vertical';
@import 'layout/sidebar/modifiers/_closed-sidebar';

// ACCESSIBILITY

// Skip-to-content link: visually hidden until focused with Tab, then pinned
// to the top-left so keyboard and screen-reader users can jump past the
// sidebar / header and straight into the page content.
.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  z-index: 2000;
  padding: 0.5rem 1rem;
  background: var(--bs-primary, #545cd8);
  color: #fff;
  text-decoration: none;
  border-radius: 0 0 0.25rem 0;
  font-weight: 600;
  transition: top 0.15s ease;

  &:focus,
  &:focus-visible {
    top: 0;
    outline: 2px solid #fff;
    outline-offset: -4px;
  }
}

// Keyboard-only focus ring. Bootstrap 5.3 ships a sensible default for
// `:focus-visible` on form controls and native buttons, but custom
// `widget-*` / `nav-link` / icon-button elements in this template don't
// inherit it — add a gentle fallback so nothing keyboard-interactive is
// invisible-focus. Opt-out via `data-focus-visible-self` for components
// that carry their own box-shadow focus ring.
:focus-visible {
  outline: 2px solid var(--bs-primary, #545cd8);
  outline-offset: 2px;
}

[data-focus-visible-self]:focus-visible {
  outline: 0;
}


// Orbit-eigene Utility-Klassen — siehe security-review HIGH-2.
// Reduzieren Inline-Style-Footprint damit weniger style="" Attribute
// im DOM landen. Bootstrap deckt font-monospace ab; hier kombinierte
// Patterns die in mehreren Pages auftauchen.
.orbit-code-badge {
  font-family: $font-family-monospace;
  font-weight: normal;
  font-size: 12px;
}
.orbit-code-badge-sm {
  font-family: $font-family-monospace;
  font-weight: normal;
  font-size: 11px;
}

// ─── Kontrast-Härtung gegen Operator-Müdigkeit ────────────────────────
// Bootstrap-Defaults haben text-muted = #6c757d auf weißem Hintergrund —
// Kontrast 4.5:1, knapp WCAG-AA, in Praxis schwer lesbar. Wir ziehen die
// muted/secondary-Farben deutlich nach dunkel. Affects: <small>, .text-muted,
// .text-secondary, Dropdown-Items, kleinere Labels in den Cards.
:root {
  --bs-secondary-color: #495057;          // gray-700, ~7:1 gegen weiß
  --bs-secondary-color-rgb: 73, 80, 87;
  --bs-tertiary-color: #6c757d;           // alter „muted"-Wert wandert auf tertiary
  --bs-tertiary-color-rgb: 108, 117, 125;
}

// Bootstrap 5.x stuft .text-muted seit 5.3 auf --bs-secondary-color um —
// aber viele alte Templates haben noch hartcodiertes color: $gray-600.
// Explicit Override damit der globale Effekt sicher greift.
.text-muted {
  color: var(--bs-secondary-color) !important;
}
.small,
small {
  // Kleine Schrift hat ohnehin weniger Pixel — sollte gar nicht muted sein
  // wenn sie Information trägt.
  color: inherit;
}
// Body-Default ist OK (#212529), nur explizit anpinnen damit dunkle Bootstrap-
// Themes (DataTable hover etc.) nicht wieder auf Hellgrau fallen.
body {
  --bs-body-color: #212529;
}

